import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router";
import util from "../util/util";

export default function ConflictCount(props) {
  const [conflictCount, setConflictCount] = useState(0);
  const timeout = useRef(0);

  useEffect(() => {
    getConflictCount();
  });

  useEffect(() => {
    return () => {
      // clear the timeout set by getConflictCount;
      window.clearTimeout(timeout.current);
    };
  }, []);

  // get the conflict count;
  const getConflictCount = () => {
    // clear any existing timeout;
    clearTimeout(timeout.current);

    util.getConflicts().then(data => {
      setConflictCount(Number(data.count));

      // check again in 60 seconds;
      const delay = 60;

      // start a new timeout;
      timeout.current = setTimeout(() => {
        getConflictCount();
      }, delay * 1000);
    });
  };

  // add a global function for conflict count updates;
  window.updateConflictCount = () => {
    getConflictCount();
  };

  return (
    <Link
      className={conflictCount ? `` : `hidden`}
      to={util.returnConflictFormUrl()}
    >
      {conflictCount} Conflict{conflictCount > 1 ? `s` : ``}
    </Link>
  );
}
